import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type BundledPlaylistGraphicsType = PlaylistGraphic[];

export type BundledPlaylistGraphicStateType = {
	bundledPlaylistGraphics: BundledPlaylistGraphicsType | null;
	loading: boolean;
	error: string | null;
};

const bundledPlaylistGraphicInitialState: BundledPlaylistGraphicStateType = {
	bundledPlaylistGraphics: null,
	loading: true,
	error: null,
};

export const BUNDLED_PLAYLIST_GRAPHIC = "bundledPlaylistGraphic";
export type BUNDLED_PLAYLIST_GRAPHIC = typeof BUNDLED_PLAYLIST_GRAPHIC;

const bundledPlaylistGraphicSlice = createSlice({
	name: BUNDLED_PLAYLIST_GRAPHIC,
	initialState: bundledPlaylistGraphicInitialState,
	reducers: {
		requestGetBundledPlaylistGraphics: (state, _action: PayloadAction<{ rundownId: string }>) => {
			state.loading = true;
			state.error = null;
		},
		receiveGetBundledPlaylistGraphics: (
			state,
			{ payload }: PayloadAction<BundledPlaylistGraphicsType | null>,
		) => {
			state.loading = false;
			state.bundledPlaylistGraphics = payload;
			state.error = null;
		},
		failedGetBundledPlaylistGraphics: (state, { payload: error }: PayloadAction<string>) => {
			state.loading = false;
			state.error = error;
		},
	},
});

export const actions = bundledPlaylistGraphicSlice.actions;
export const bundledPlaylistGraphicReducer = bundledPlaylistGraphicSlice.reducer;
